import { default as indexc0DiFXnGPeMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/ai/index.vue?macro=true";
import { default as dashboardcWDaH8as2OMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/call-center/dashboard.vue?macro=true";
import { default as indexC1x2L8IJyPMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/dashboard/index.vue?macro=true";
import { default as indexsFf5gaem97Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/home/index.vue?macro=true";
import { default as markdowngUov8UgVa2Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/home/markdown.vue?macro=true";
import { default as indexDypWOp4leEMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/index.vue?macro=true";
import { default as _91id_93tEL3d1BRbgMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-form-submission/[id].vue?macro=true";
import { default as lead_45form_45submissionK8ZoHjVWynMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-form-submission.vue?macro=true";
import { default as _91slug_93yRrpCIJbQ4Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-public-form/[slug].vue?macro=true";
import { default as payment_45requiredDXqlJeuMCWMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/payment-required.vue?macro=true";
import { default as privacy_45policyz34wyxUoBCMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/privacy-policy.vue?macro=true";
import { default as _91id_93TEKlT0padxMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/products/[id].vue?macro=true";
import { default as indexxF8Ac8BQsCMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/products/index.vue?macro=true";
import { default as profilehQVVX7ycjZMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/profile.vue?macro=true";
import { default as indexpiGWCdLdEfMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/roles/index.vue?macro=true";
import { default as indexB4wBkOsEEEMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sentiment-analysis/index.vue?macro=true";
import { default as settings9yhnEDfixIMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/settings.vue?macro=true";
import { default as indexKsF4euAmUFMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/balance/index.vue?macro=true";
import { default as indexgVjlEGhFkyMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/index.vue?macro=true";
import { default as indexpo0ciR53j9Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/reports/index.vue?macro=true";
import { default as indexktfszzl9kPMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/stock/index.vue?macro=true";
import { default as locationsbOwjrbs9WgMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/stock/locations.vue?macro=true";
import { default as thank_45yougBfnfec9jdMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/thank-you.vue?macro=true";
import { default as whats_45newO4iiSzLNtsMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/whats-new.vue?macro=true";
import { default as indexus9dK72dzUMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/call-groups/index.vue?macro=true";
import { default as indexuWVB4iQ2twMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/call-histories/index.vue?macro=true";
import { default as dashboard0OFOIm3hKXMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/dashboard.vue?macro=true";
import { default as indexViTg4P2mqhMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/kpi/index.vue?macro=true";
import { default as privacy_45policyhwvERgSWeVMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/privacy-policy.vue?macro=true";
import { default as reportwAvPTP8MzsMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/report.vue?macro=true";
import { default as indexsSpNBq8ykXMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/unhandled-calls/index.vue?macro=true";
import { default as summaryEmoK90k6WzMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/summary.vue?macro=true";
import { default as _91id_930rxqlZEj2xMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks/[id].vue?macro=true";
import { default as reports0wN06w7GFgMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks/reports.vue?macro=true";
import { default as tasksY41gfPrXJnMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks.vue?macro=true";
import { default as _91id_93U3gpFNEo1aMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/[id].vue?macro=true";
import { default as indexwWHBzTpeKrMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/dial-session/index.vue?macro=true";
import { default as indexWiavAzoHTKMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/index.vue?macro=true";
import { default as _91id_93SU2kK1lRUdMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/customers/[id].vue?macro=true";
import { default as index3ONSTKp3OoMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/customers/index.vue?macro=true";
import { default as integrationxe1sv5q8H4Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/integration.vue?macro=true";
import { default as _91id_93JS9qQxMnu6Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/order-automations/[id].vue?macro=true";
import { default as indexLySEgvFsNvMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/order-automations/index.vue?macro=true";
import { default as _91id_93mT2O02i1ggMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/[id].vue?macro=true";
import { default as indexNOQ5nxb7zPMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/index.vue?macro=true";
import { default as managedrbyLnRmH0Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/stage/manage.vue?macro=true";
import { default as reportsOclyrfCJJUMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/reports.vue?macro=true";
import { default as website_45integrations4mbso426T8Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/website-integrations.vue?macro=true";
import { default as indexwLXq4ftARwMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/automation-tickets/index.vue?macro=true";
import { default as index9S2Bc7iEthMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/automations/index.vue?macro=true";
import { default as dashboardaLDVMNvRCgMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/dashboard.vue?macro=true";
import { default as gallery4HcEGxwIwkMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/gallery.vue?macro=true";
import { default as index6wz7XRMaGtMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/histories/index.vue?macro=true";
import { default as inboxriQugaMCpRMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/inbox.vue?macro=true";
import { default as pagesL4qFadlepDMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/pages.vue?macro=true";
import { default as templates9eP3BpiufNMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/reply/templates.vue?macro=true";
import { default as reportsIgZaWJ40UOMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/reports.vue?macro=true";
import { default as indexBchgJuO62nMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/scheduled-message/index.vue?macro=true";
import { default as indexZnGVtKFMkUMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/ticket-list/index.vue?macro=true";
import { default as message_45templatesFtCeLeWHCGMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-accounts/[id]/message-templates.vue?macro=true";
import { default as _91id_93LcgsBtEftTMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-campaigns/[id].vue?macro=true";
import { default as indexGYo7Qni4DlMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-campaigns/index.vue?macro=true";
import { default as campaignsMe9R1zTTg2Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/campaigns.vue?macro=true";
import { default as indexbM2UpmtfekMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/dashboard/index.vue?macro=true";
import { default as indexrmV4jX9a5pMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/discount-requests/index.vue?macro=true";
import { default as indexTk6sJKywtlMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/external-lead-submissions/index.vue?macro=true";
import { default as indexRNTDEUCVyBMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/lead-public-form-submissions/index.vue?macro=true";
import { default as _91id_93I726iDFdTZMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/lead-public-forms/[id].vue?macro=true";
import { default as _91id_93ye3Ci69RyLMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/[id].vue?macro=true";
import { default as indexMaqzgE9RtiMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/index.vue?macro=true";
import { default as manage8I0R5kob3CMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/status/manage.vue?macro=true";
import { default as _91id_93t3lcAdO0iJMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/[id].vue?macro=true";
import { default as indexY1QeY2OBdsMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/index.vue?macro=true";
import { default as managejGo6tNIZQzMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/stages/manage.vue?macro=true";
import { default as productsZHkFwEWsHwMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/organizations/[id]/products.vue?macro=true";
import { default as indexUKFjJPapqpMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/organizations/index.vue?macro=true";
import { default as index32gZHeWRDnMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/partners/index.vue?macro=true";
import { default as indexUuBdxrAuyVMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/payment-items/index.vue?macro=true";
import { default as quotesFA5TqR9NibMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/quotes.vue?macro=true";
import { default as indexpdczIyA28wMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/reports/index.vue?macro=true";
import { default as indexTUCl76HOeHMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/request-submissions/index.vue?macro=true";
import { default as indexSXDzfHq9KBMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/targets/index.vue?macro=true";
import { default as _91id_935RndewZdFQMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/[id].vue?macro=true";
import { default as indexIVGx66AxoKMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/index.vue?macro=true";
import { default as indexJleyiNlNJgMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/reports/index.vue?macro=true";
import { default as _91id_93mpRotZ6tHpMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/[id].vue?macro=true";
import { default as indextgwTkjHRa7Meta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/dashboard/index.vue?macro=true";
import { default as indexYfHobTMMtYMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/index.vue?macro=true";
import { default as indexGkuUquOk0UMeta } from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/reports/index.vue?macro=true";
export default [
  {
    name: indexc0DiFXnGPeMeta?.name ?? "ai",
    path: indexc0DiFXnGPeMeta?.path ?? "/ai",
    meta: indexc0DiFXnGPeMeta || {},
    alias: indexc0DiFXnGPeMeta?.alias || [],
    redirect: indexc0DiFXnGPeMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardcWDaH8as2OMeta?.name ?? "call-center-dashboard",
    path: dashboardcWDaH8as2OMeta?.path ?? "/call-center/dashboard",
    meta: dashboardcWDaH8as2OMeta || {},
    alias: dashboardcWDaH8as2OMeta?.alias || [],
    redirect: dashboardcWDaH8as2OMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/call-center/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexC1x2L8IJyPMeta?.name ?? "dashboard",
    path: indexC1x2L8IJyPMeta?.path ?? "/dashboard",
    meta: indexC1x2L8IJyPMeta || {},
    alias: indexC1x2L8IJyPMeta?.alias || [],
    redirect: indexC1x2L8IJyPMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexsFf5gaem97Meta?.name ?? "home",
    path: indexsFf5gaem97Meta?.path ?? "/home",
    meta: indexsFf5gaem97Meta || {},
    alias: indexsFf5gaem97Meta?.alias || [],
    redirect: indexsFf5gaem97Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: markdowngUov8UgVa2Meta?.name ?? "home-markdown",
    path: markdowngUov8UgVa2Meta?.path ?? "/home/markdown",
    meta: markdowngUov8UgVa2Meta || {},
    alias: markdowngUov8UgVa2Meta?.alias || [],
    redirect: markdowngUov8UgVa2Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/home/markdown.vue").then(m => m.default || m)
  },
  {
    name: indexDypWOp4leEMeta?.name ?? "index",
    path: indexDypWOp4leEMeta?.path ?? "/",
    meta: indexDypWOp4leEMeta || {},
    alias: indexDypWOp4leEMeta?.alias || [],
    redirect: indexDypWOp4leEMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: lead_45form_45submissionK8ZoHjVWynMeta?.name ?? "lead-form-submission",
    path: lead_45form_45submissionK8ZoHjVWynMeta?.path ?? "/lead-form-submission",
    children: [
  {
    name: _91id_93tEL3d1BRbgMeta?.name ?? "lead-form-submission-id",
    path: _91id_93tEL3d1BRbgMeta?.path ?? ":id()",
    meta: _91id_93tEL3d1BRbgMeta || {},
    alias: _91id_93tEL3d1BRbgMeta?.alias || [],
    redirect: _91id_93tEL3d1BRbgMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-form-submission/[id].vue").then(m => m.default || m)
  }
],
    meta: lead_45form_45submissionK8ZoHjVWynMeta || {},
    alias: lead_45form_45submissionK8ZoHjVWynMeta?.alias || [],
    redirect: lead_45form_45submissionK8ZoHjVWynMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-form-submission.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93yRrpCIJbQ4Meta?.name ?? "lead-public-form-slug",
    path: _91slug_93yRrpCIJbQ4Meta?.path ?? "/lead-public-form/:slug()",
    meta: _91slug_93yRrpCIJbQ4Meta || {},
    alias: _91slug_93yRrpCIJbQ4Meta?.alias || [],
    redirect: _91slug_93yRrpCIJbQ4Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/lead-public-form/[slug].vue").then(m => m.default || m)
  },
  {
    name: payment_45requiredDXqlJeuMCWMeta?.name ?? "payment-required",
    path: payment_45requiredDXqlJeuMCWMeta?.path ?? "/payment-required",
    meta: payment_45requiredDXqlJeuMCWMeta || {},
    alias: payment_45requiredDXqlJeuMCWMeta?.alias || [],
    redirect: payment_45requiredDXqlJeuMCWMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/payment-required.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyz34wyxUoBCMeta?.name ?? "privacy-policy",
    path: privacy_45policyz34wyxUoBCMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyz34wyxUoBCMeta || {},
    alias: privacy_45policyz34wyxUoBCMeta?.alias || [],
    redirect: privacy_45policyz34wyxUoBCMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: _91id_93TEKlT0padxMeta?.name ?? "products-id",
    path: _91id_93TEKlT0padxMeta?.path ?? "/products/:id()",
    meta: _91id_93TEKlT0padxMeta || {},
    alias: _91id_93TEKlT0padxMeta?.alias || [],
    redirect: _91id_93TEKlT0padxMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/products/[id].vue").then(m => m.default || m)
  },
  {
    name: indexxF8Ac8BQsCMeta?.name ?? "products",
    path: indexxF8Ac8BQsCMeta?.path ?? "/products",
    meta: indexxF8Ac8BQsCMeta || {},
    alias: indexxF8Ac8BQsCMeta?.alias || [],
    redirect: indexxF8Ac8BQsCMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: profilehQVVX7ycjZMeta?.name ?? "profile",
    path: profilehQVVX7ycjZMeta?.path ?? "/profile",
    meta: profilehQVVX7ycjZMeta || {},
    alias: profilehQVVX7ycjZMeta?.alias || [],
    redirect: profilehQVVX7ycjZMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: indexpiGWCdLdEfMeta?.name ?? "roles",
    path: indexpiGWCdLdEfMeta?.path ?? "/roles",
    meta: indexpiGWCdLdEfMeta || {},
    alias: indexpiGWCdLdEfMeta?.alias || [],
    redirect: indexpiGWCdLdEfMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexB4wBkOsEEEMeta?.name ?? "sentiment-analysis",
    path: indexB4wBkOsEEEMeta?.path ?? "/sentiment-analysis",
    meta: indexB4wBkOsEEEMeta || {},
    alias: indexB4wBkOsEEEMeta?.alias || [],
    redirect: indexB4wBkOsEEEMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sentiment-analysis/index.vue").then(m => m.default || m)
  },
  {
    name: settings9yhnEDfixIMeta?.name ?? "settings",
    path: settings9yhnEDfixIMeta?.path ?? "/settings",
    meta: settings9yhnEDfixIMeta || {},
    alias: settings9yhnEDfixIMeta?.alias || [],
    redirect: settings9yhnEDfixIMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/settings.vue").then(m => m.default || m)
  },
  {
    name: indexKsF4euAmUFMeta?.name ?? "sms-histories-balance",
    path: indexKsF4euAmUFMeta?.path ?? "/sms-histories/balance",
    meta: indexKsF4euAmUFMeta || {},
    alias: indexKsF4euAmUFMeta?.alias || [],
    redirect: indexKsF4euAmUFMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexgVjlEGhFkyMeta?.name ?? "sms-histories",
    path: indexgVjlEGhFkyMeta?.path ?? "/sms-histories",
    meta: indexgVjlEGhFkyMeta || {},
    alias: indexgVjlEGhFkyMeta?.alias || [],
    redirect: indexgVjlEGhFkyMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/index.vue").then(m => m.default || m)
  },
  {
    name: indexpo0ciR53j9Meta?.name ?? "sms-histories-reports",
    path: indexpo0ciR53j9Meta?.path ?? "/sms-histories/reports",
    meta: indexpo0ciR53j9Meta || {},
    alias: indexpo0ciR53j9Meta?.alias || [],
    redirect: indexpo0ciR53j9Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/sms-histories/reports/index.vue").then(m => m.default || m)
  },
  {
    name: indexktfszzl9kPMeta?.name ?? "stock",
    path: indexktfszzl9kPMeta?.path ?? "/stock",
    meta: indexktfszzl9kPMeta || {},
    alias: indexktfszzl9kPMeta?.alias || [],
    redirect: indexktfszzl9kPMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/stock/index.vue").then(m => m.default || m)
  },
  {
    name: locationsbOwjrbs9WgMeta?.name ?? "stock-locations",
    path: locationsbOwjrbs9WgMeta?.path ?? "/stock/locations",
    meta: locationsbOwjrbs9WgMeta || {},
    alias: locationsbOwjrbs9WgMeta?.alias || [],
    redirect: locationsbOwjrbs9WgMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/stock/locations.vue").then(m => m.default || m)
  },
  {
    name: thank_45yougBfnfec9jdMeta?.name ?? "thank-you",
    path: thank_45yougBfnfec9jdMeta?.path ?? "/thank-you",
    meta: thank_45yougBfnfec9jdMeta || {},
    alias: thank_45yougBfnfec9jdMeta?.alias || [],
    redirect: thank_45yougBfnfec9jdMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: whats_45newO4iiSzLNtsMeta?.name ?? "whats-new",
    path: whats_45newO4iiSzLNtsMeta?.path ?? "/whats-new",
    meta: whats_45newO4iiSzLNtsMeta || {},
    alias: whats_45newO4iiSzLNtsMeta?.alias || [],
    redirect: whats_45newO4iiSzLNtsMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/pages/whats-new.vue").then(m => m.default || m)
  },
  {
    name: indexus9dK72dzUMeta?.name ?? "cc-pages-call-groups-index",
    path: indexus9dK72dzUMeta?.path ?? "/call-center/call-groups",
    meta: indexus9dK72dzUMeta || {},
    alias: indexus9dK72dzUMeta?.alias || [],
    redirect: indexus9dK72dzUMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/call-groups/index.vue").then(m => m.default || m)
  },
  {
    name: indexuWVB4iQ2twMeta?.name ?? "cc-pages-call-histories-index",
    path: indexuWVB4iQ2twMeta?.path ?? "/call-center/call-histories",
    meta: indexuWVB4iQ2twMeta || {},
    alias: indexuWVB4iQ2twMeta?.alias || [],
    redirect: indexuWVB4iQ2twMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/call-histories/index.vue").then(m => m.default || m)
  },
  {
    name: dashboard0OFOIm3hKXMeta?.name ?? "cc-pages-dashboard",
    path: dashboard0OFOIm3hKXMeta?.path ?? "/call-center/dashboard",
    meta: dashboard0OFOIm3hKXMeta || {},
    alias: dashboard0OFOIm3hKXMeta?.alias || [],
    redirect: dashboard0OFOIm3hKXMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexViTg4P2mqhMeta?.name ?? "cc-pages-kpi-index",
    path: indexViTg4P2mqhMeta?.path ?? "/call-center/kpi",
    meta: indexViTg4P2mqhMeta || {},
    alias: indexViTg4P2mqhMeta?.alias || [],
    redirect: indexViTg4P2mqhMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/kpi/index.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyhwvERgSWeVMeta?.name ?? "cc-pages-privacy-policy",
    path: privacy_45policyhwvERgSWeVMeta?.path ?? "/call-center/privacy-policy",
    meta: privacy_45policyhwvERgSWeVMeta || {},
    alias: privacy_45policyhwvERgSWeVMeta?.alias || [],
    redirect: privacy_45policyhwvERgSWeVMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: reportwAvPTP8MzsMeta?.name ?? "cc-pages-report",
    path: reportwAvPTP8MzsMeta?.path ?? "/call-center/report",
    meta: reportwAvPTP8MzsMeta || {},
    alias: reportwAvPTP8MzsMeta?.alias || [],
    redirect: reportwAvPTP8MzsMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/report.vue").then(m => m.default || m)
  },
  {
    name: indexsSpNBq8ykXMeta?.name ?? "cc-pages-unhandled-calls-index",
    path: indexsSpNBq8ykXMeta?.path ?? "/call-center/unhandled-calls",
    meta: indexsSpNBq8ykXMeta || {},
    alias: indexsSpNBq8ykXMeta?.alias || [],
    redirect: indexsSpNBq8ykXMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/cc/pages/unhandled-calls/index.vue").then(m => m.default || m)
  },
  {
    name: summaryEmoK90k6WzMeta?.name ?? "task-pages-summary",
    path: summaryEmoK90k6WzMeta?.path ?? "/task-manager/summary",
    meta: summaryEmoK90k6WzMeta || {},
    alias: summaryEmoK90k6WzMeta?.alias || [],
    redirect: summaryEmoK90k6WzMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/summary.vue").then(m => m.default || m)
  },
  {
    name: _91id_930rxqlZEj2xMeta?.name ?? "task-pages-tasks-id",
    path: _91id_930rxqlZEj2xMeta?.path ?? "/task-manager/tasks/:id",
    meta: _91id_930rxqlZEj2xMeta || {},
    alias: _91id_930rxqlZEj2xMeta?.alias || [],
    redirect: _91id_930rxqlZEj2xMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks/[id].vue").then(m => m.default || m)
  },
  {
    name: reports0wN06w7GFgMeta?.name ?? "task-pages-tasks-reports",
    path: reports0wN06w7GFgMeta?.path ?? "/task-manager/tasks/reports",
    meta: reports0wN06w7GFgMeta || {},
    alias: reports0wN06w7GFgMeta?.alias || [],
    redirect: reports0wN06w7GFgMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks/reports.vue").then(m => m.default || m)
  },
  {
    name: tasksY41gfPrXJnMeta?.name ?? "task-pages-tasks",
    path: tasksY41gfPrXJnMeta?.path ?? "/task-manager/tasks",
    meta: tasksY41gfPrXJnMeta || {},
    alias: tasksY41gfPrXJnMeta?.alias || [],
    redirect: tasksY41gfPrXJnMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/task-manager/pages/tasks.vue").then(m => m.default || m)
  },
  {
    name: _91id_93U3gpFNEo1aMeta?.name ?? "tele-pages-auto-dialer-id",
    path: _91id_93U3gpFNEo1aMeta?.path ?? "/tele-sales/auto-dialer/:id",
    meta: _91id_93U3gpFNEo1aMeta || {},
    alias: _91id_93U3gpFNEo1aMeta?.alias || [],
    redirect: _91id_93U3gpFNEo1aMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/[id].vue").then(m => m.default || m)
  },
  {
    name: indexwWHBzTpeKrMeta?.name ?? "tele-pages-auto-dialer/dial-session-index",
    path: indexwWHBzTpeKrMeta?.path ?? "/tele-sales/auto-dialer/dial-session",
    meta: indexwWHBzTpeKrMeta || {},
    alias: indexwWHBzTpeKrMeta?.alias || [],
    redirect: indexwWHBzTpeKrMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/dial-session/index.vue").then(m => m.default || m)
  },
  {
    name: indexWiavAzoHTKMeta?.name ?? "tele-pages-auto-dialer-index",
    path: indexWiavAzoHTKMeta?.path ?? "/tele-sales/auto-dialer",
    meta: indexWiavAzoHTKMeta || {},
    alias: indexWiavAzoHTKMeta?.alias || [],
    redirect: indexWiavAzoHTKMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/auto-dialer/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93SU2kK1lRUdMeta?.name ?? "tele-pages-customers-id",
    path: _91id_93SU2kK1lRUdMeta?.path ?? "/tele-sales/customers/:id",
    meta: _91id_93SU2kK1lRUdMeta || {},
    alias: _91id_93SU2kK1lRUdMeta?.alias || [],
    redirect: _91id_93SU2kK1lRUdMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/customers/[id].vue").then(m => m.default || m)
  },
  {
    name: index3ONSTKp3OoMeta?.name ?? "tele-pages-customers-index",
    path: index3ONSTKp3OoMeta?.path ?? "/tele-sales/customers",
    meta: index3ONSTKp3OoMeta || {},
    alias: index3ONSTKp3OoMeta?.alias || [],
    redirect: index3ONSTKp3OoMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/tele-sales/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: integrationxe1sv5q8H4Meta?.name ?? "order-management-pages-integration",
    path: integrationxe1sv5q8H4Meta?.path ?? "/order-manager/integration",
    meta: integrationxe1sv5q8H4Meta || {},
    alias: integrationxe1sv5q8H4Meta?.alias || [],
    redirect: integrationxe1sv5q8H4Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/integration.vue").then(m => m.default || m)
  },
  {
    name: _91id_93JS9qQxMnu6Meta?.name ?? "order-management-pages-order-automations-id",
    path: _91id_93JS9qQxMnu6Meta?.path ?? "/order-manager/order-automations/:id",
    meta: _91id_93JS9qQxMnu6Meta || {},
    alias: _91id_93JS9qQxMnu6Meta?.alias || [],
    redirect: _91id_93JS9qQxMnu6Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/order-automations/[id].vue").then(m => m.default || m)
  },
  {
    name: indexLySEgvFsNvMeta?.name ?? "order-management-pages-order-automations-index",
    path: indexLySEgvFsNvMeta?.path ?? "/order-manager/order-automations",
    meta: indexLySEgvFsNvMeta || {},
    alias: indexLySEgvFsNvMeta?.alias || [],
    redirect: indexLySEgvFsNvMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/order-automations/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93mT2O02i1ggMeta?.name ?? "order-management-pages-orders-id",
    path: _91id_93mT2O02i1ggMeta?.path ?? "/order-manager/orders/:id",
    meta: _91id_93mT2O02i1ggMeta || {},
    alias: _91id_93mT2O02i1ggMeta?.alias || [],
    redirect: _91id_93mT2O02i1ggMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: indexNOQ5nxb7zPMeta?.name ?? "order-management-pages-orders-index",
    path: indexNOQ5nxb7zPMeta?.path ?? "/order-manager/orders",
    meta: indexNOQ5nxb7zPMeta || {},
    alias: indexNOQ5nxb7zPMeta?.alias || [],
    redirect: indexNOQ5nxb7zPMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: managedrbyLnRmH0Meta?.name ?? "order-management-pages-orders/stage-manage",
    path: managedrbyLnRmH0Meta?.path ?? "/order-manager/orders/stage/manage",
    meta: managedrbyLnRmH0Meta || {},
    alias: managedrbyLnRmH0Meta?.alias || [],
    redirect: managedrbyLnRmH0Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/orders/stage/manage.vue").then(m => m.default || m)
  },
  {
    name: reportsOclyrfCJJUMeta?.name ?? "order-management-pages-reports",
    path: reportsOclyrfCJJUMeta?.path ?? "/order-manager/reports",
    meta: reportsOclyrfCJJUMeta || {},
    alias: reportsOclyrfCJJUMeta?.alias || [],
    redirect: reportsOclyrfCJJUMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/reports.vue").then(m => m.default || m)
  },
  {
    name: website_45integrations4mbso426T8Meta?.name ?? "order-management-pages-website-integrations",
    path: website_45integrations4mbso426T8Meta?.path ?? "/order-manager/website-integrations",
    meta: website_45integrations4mbso426T8Meta || {},
    alias: website_45integrations4mbso426T8Meta?.alias || [],
    redirect: website_45integrations4mbso426T8Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/order-manager/pages/website-integrations.vue").then(m => m.default || m)
  },
  {
    name: indexwLXq4ftARwMeta?.name ?? "help-desk-help-desk--automation-tickets-index",
    path: indexwLXq4ftARwMeta?.path ?? "/help-desk/automation-tickets",
    meta: indexwLXq4ftARwMeta || {},
    alias: indexwLXq4ftARwMeta?.alias || [],
    redirect: indexwLXq4ftARwMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/automation-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: index9S2Bc7iEthMeta?.name ?? "help-desk-help-desk--automations-index",
    path: index9S2Bc7iEthMeta?.path ?? "/help-desk/automations",
    meta: index9S2Bc7iEthMeta || {},
    alias: index9S2Bc7iEthMeta?.alias || [],
    redirect: index9S2Bc7iEthMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/automations/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardaLDVMNvRCgMeta?.name ?? "help-desk-help-desk--dashboard",
    path: dashboardaLDVMNvRCgMeta?.path ?? "/help-desk/dashboard",
    meta: dashboardaLDVMNvRCgMeta || {},
    alias: dashboardaLDVMNvRCgMeta?.alias || [],
    redirect: dashboardaLDVMNvRCgMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: gallery4HcEGxwIwkMeta?.name ?? "help-desk-help-desk--gallery",
    path: gallery4HcEGxwIwkMeta?.path ?? "/help-desk/gallery",
    meta: gallery4HcEGxwIwkMeta || {},
    alias: gallery4HcEGxwIwkMeta?.alias || [],
    redirect: gallery4HcEGxwIwkMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: index6wz7XRMaGtMeta?.name ?? "help-desk-help-desk--histories-index",
    path: index6wz7XRMaGtMeta?.path ?? "/help-desk/histories",
    meta: index6wz7XRMaGtMeta || {},
    alias: index6wz7XRMaGtMeta?.alias || [],
    redirect: index6wz7XRMaGtMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/histories/index.vue").then(m => m.default || m)
  },
  {
    name: inboxriQugaMCpRMeta?.name ?? "help-desk-help-desk--inbox",
    path: inboxriQugaMCpRMeta?.path ?? "/help-desk/inbox",
    meta: inboxriQugaMCpRMeta || {},
    alias: inboxriQugaMCpRMeta?.alias || [],
    redirect: inboxriQugaMCpRMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/inbox.vue").then(m => m.default || m)
  },
  {
    name: pagesL4qFadlepDMeta?.name ?? "help-desk-help-desk--pages",
    path: pagesL4qFadlepDMeta?.path ?? "/help-desk/pages",
    meta: pagesL4qFadlepDMeta || {},
    alias: pagesL4qFadlepDMeta?.alias || [],
    redirect: pagesL4qFadlepDMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/pages.vue").then(m => m.default || m)
  },
  {
    name: templates9eP3BpiufNMeta?.name ?? "help-desk-help-desk--reply-templates",
    path: templates9eP3BpiufNMeta?.path ?? "/help-desk/reply/templates",
    meta: templates9eP3BpiufNMeta || {},
    alias: templates9eP3BpiufNMeta?.alias || [],
    redirect: templates9eP3BpiufNMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/reply/templates.vue").then(m => m.default || m)
  },
  {
    name: reportsIgZaWJ40UOMeta?.name ?? "help-desk-help-desk--reports",
    path: reportsIgZaWJ40UOMeta?.path ?? "/help-desk/reports",
    meta: reportsIgZaWJ40UOMeta || {},
    alias: reportsIgZaWJ40UOMeta?.alias || [],
    redirect: reportsIgZaWJ40UOMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/reports.vue").then(m => m.default || m)
  },
  {
    name: indexBchgJuO62nMeta?.name ?? "help-desk-help-desk--scheduled-message-index",
    path: indexBchgJuO62nMeta?.path ?? "/help-desk/scheduled-message",
    meta: indexBchgJuO62nMeta || {},
    alias: indexBchgJuO62nMeta?.alias || [],
    redirect: indexBchgJuO62nMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/scheduled-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexZnGVtKFMkUMeta?.name ?? "help-desk-help-desk--ticket-list-index",
    path: indexZnGVtKFMkUMeta?.path ?? "/help-desk/ticket-list",
    meta: indexZnGVtKFMkUMeta || {},
    alias: indexZnGVtKFMkUMeta?.alias || [],
    redirect: indexZnGVtKFMkUMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/ticket-list/index.vue").then(m => m.default || m)
  },
  {
    name: message_45templatesFtCeLeWHCGMeta?.name ?? "help-desk-help-desk--whatsapp-accounts-id-message-templates",
    path: message_45templatesFtCeLeWHCGMeta?.path ?? "/help-desk/whatsapp-accounts/:id/message-templates",
    meta: message_45templatesFtCeLeWHCGMeta || {},
    alias: message_45templatesFtCeLeWHCGMeta?.alias || [],
    redirect: message_45templatesFtCeLeWHCGMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-accounts/[id]/message-templates.vue").then(m => m.default || m)
  },
  {
    name: _91id_93LcgsBtEftTMeta?.name ?? "help-desk-help-desk--whatsapp-campaigns-id",
    path: _91id_93LcgsBtEftTMeta?.path ?? "/help-desk/whatsapp-campaigns/:id",
    meta: _91id_93LcgsBtEftTMeta || {},
    alias: _91id_93LcgsBtEftTMeta?.alias || [],
    redirect: _91id_93LcgsBtEftTMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-campaigns/[id].vue").then(m => m.default || m)
  },
  {
    name: indexGYo7Qni4DlMeta?.name ?? "help-desk-help-desk--whatsapp-campaigns-index",
    path: indexGYo7Qni4DlMeta?.path ?? "/help-desk/whatsapp-campaigns",
    meta: indexGYo7Qni4DlMeta || {},
    alias: indexGYo7Qni4DlMeta?.alias || [],
    redirect: indexGYo7Qni4DlMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/help-desk/pages/whatsapp-campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: campaignsMe9R1zTTg2Meta?.name ?? "crm--campaigns",
    path: campaignsMe9R1zTTg2Meta?.path ?? "/crm/campaigns",
    meta: campaignsMe9R1zTTg2Meta || {},
    alias: campaignsMe9R1zTTg2Meta?.alias || [],
    redirect: campaignsMe9R1zTTg2Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/campaigns.vue").then(m => m.default || m)
  },
  {
    name: indexbM2UpmtfekMeta?.name ?? "crm--dashboard-index",
    path: indexbM2UpmtfekMeta?.path ?? "/crm/dashboard",
    meta: indexbM2UpmtfekMeta || {},
    alias: indexbM2UpmtfekMeta?.alias || [],
    redirect: indexbM2UpmtfekMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexrmV4jX9a5pMeta?.name ?? "crm--discount-requests-index",
    path: indexrmV4jX9a5pMeta?.path ?? "/crm/discount-requests",
    meta: indexrmV4jX9a5pMeta || {},
    alias: indexrmV4jX9a5pMeta?.alias || [],
    redirect: indexrmV4jX9a5pMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/discount-requests/index.vue").then(m => m.default || m)
  },
  {
    name: indexTk6sJKywtlMeta?.name ?? "crm--external-lead-submissions-index",
    path: indexTk6sJKywtlMeta?.path ?? "/crm/external-lead-submissions",
    meta: indexTk6sJKywtlMeta || {},
    alias: indexTk6sJKywtlMeta?.alias || [],
    redirect: indexTk6sJKywtlMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/external-lead-submissions/index.vue").then(m => m.default || m)
  },
  {
    name: indexRNTDEUCVyBMeta?.name ?? "crm--lead-public-form-submissions-index",
    path: indexRNTDEUCVyBMeta?.path ?? "/crm/lead-public-form-submissions",
    meta: indexRNTDEUCVyBMeta || {},
    alias: indexRNTDEUCVyBMeta?.alias || [],
    redirect: indexRNTDEUCVyBMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/lead-public-form-submissions/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93I726iDFdTZMeta?.name ?? "crm--lead-public-forms-id",
    path: _91id_93I726iDFdTZMeta?.path ?? "/crm/lead-public-forms/:id",
    meta: _91id_93I726iDFdTZMeta || {},
    alias: _91id_93I726iDFdTZMeta?.alias || [],
    redirect: _91id_93I726iDFdTZMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/lead-public-forms/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ye3Ci69RyLMeta?.name ?? "crm--leads-id",
    path: _91id_93ye3Ci69RyLMeta?.path ?? "/crm/leads/:id",
    meta: _91id_93ye3Ci69RyLMeta || {},
    alias: _91id_93ye3Ci69RyLMeta?.alias || [],
    redirect: _91id_93ye3Ci69RyLMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/[id].vue").then(m => m.default || m)
  },
  {
    name: indexMaqzgE9RtiMeta?.name ?? "crm--leads-index",
    path: indexMaqzgE9RtiMeta?.path ?? "/crm/leads",
    meta: indexMaqzgE9RtiMeta || {},
    alias: indexMaqzgE9RtiMeta?.alias || [],
    redirect: indexMaqzgE9RtiMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/index.vue").then(m => m.default || m)
  },
  {
    name: manage8I0R5kob3CMeta?.name ?? "crm--leads-status-manage",
    path: manage8I0R5kob3CMeta?.path ?? "/crm/leads/status/manage",
    meta: manage8I0R5kob3CMeta || {},
    alias: manage8I0R5kob3CMeta?.alias || [],
    redirect: manage8I0R5kob3CMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/leads/status/manage.vue").then(m => m.default || m)
  },
  {
    name: _91id_93t3lcAdO0iJMeta?.name ?? "crm--opportunities-id",
    path: _91id_93t3lcAdO0iJMeta?.path ?? "/crm/opportunities/:id",
    meta: _91id_93t3lcAdO0iJMeta || {},
    alias: _91id_93t3lcAdO0iJMeta?.alias || [],
    redirect: _91id_93t3lcAdO0iJMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/[id].vue").then(m => m.default || m)
  },
  {
    name: indexY1QeY2OBdsMeta?.name ?? "crm--opportunities-index",
    path: indexY1QeY2OBdsMeta?.path ?? "/crm/opportunities",
    meta: indexY1QeY2OBdsMeta || {},
    alias: indexY1QeY2OBdsMeta?.alias || [],
    redirect: indexY1QeY2OBdsMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/index.vue").then(m => m.default || m)
  },
  {
    name: managejGo6tNIZQzMeta?.name ?? "crm--opportunities-stages-manage",
    path: managejGo6tNIZQzMeta?.path ?? "/crm/opportunities/stages/manage",
    meta: managejGo6tNIZQzMeta || {},
    alias: managejGo6tNIZQzMeta?.alias || [],
    redirect: managejGo6tNIZQzMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/opportunities/stages/manage.vue").then(m => m.default || m)
  },
  {
    name: productsZHkFwEWsHwMeta?.name ?? "crm--organizations-id-products",
    path: productsZHkFwEWsHwMeta?.path ?? "/crm/organizations/:id/products",
    meta: productsZHkFwEWsHwMeta || {},
    alias: productsZHkFwEWsHwMeta?.alias || [],
    redirect: productsZHkFwEWsHwMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/organizations/[id]/products.vue").then(m => m.default || m)
  },
  {
    name: indexUKFjJPapqpMeta?.name ?? "crm--organizations-index",
    path: indexUKFjJPapqpMeta?.path ?? "/crm/organizations",
    meta: indexUKFjJPapqpMeta || {},
    alias: indexUKFjJPapqpMeta?.alias || [],
    redirect: indexUKFjJPapqpMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/organizations/index.vue").then(m => m.default || m)
  },
  {
    name: index32gZHeWRDnMeta?.name ?? "crm--partners-index",
    path: index32gZHeWRDnMeta?.path ?? "/crm/partners",
    meta: index32gZHeWRDnMeta || {},
    alias: index32gZHeWRDnMeta?.alias || [],
    redirect: index32gZHeWRDnMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: indexUuBdxrAuyVMeta?.name ?? "crm--payment-items-index",
    path: indexUuBdxrAuyVMeta?.path ?? "/crm/payment-items",
    meta: indexUuBdxrAuyVMeta || {},
    alias: indexUuBdxrAuyVMeta?.alias || [],
    redirect: indexUuBdxrAuyVMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/payment-items/index.vue").then(m => m.default || m)
  },
  {
    name: quotesFA5TqR9NibMeta?.name ?? "crm--quotes",
    path: quotesFA5TqR9NibMeta?.path ?? "/crm/quotes",
    meta: quotesFA5TqR9NibMeta || {},
    alias: quotesFA5TqR9NibMeta?.alias || [],
    redirect: quotesFA5TqR9NibMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/quotes.vue").then(m => m.default || m)
  },
  {
    name: indexpdczIyA28wMeta?.name ?? "crm--reports-index",
    path: indexpdczIyA28wMeta?.path ?? "/crm/reports",
    meta: indexpdczIyA28wMeta || {},
    alias: indexpdczIyA28wMeta?.alias || [],
    redirect: indexpdczIyA28wMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: indexTUCl76HOeHMeta?.name ?? "crm--request-submissions-index",
    path: indexTUCl76HOeHMeta?.path ?? "/crm/request-submissions",
    meta: indexTUCl76HOeHMeta || {},
    alias: indexTUCl76HOeHMeta?.alias || [],
    redirect: indexTUCl76HOeHMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/request-submissions/index.vue").then(m => m.default || m)
  },
  {
    name: indexSXDzfHq9KBMeta?.name ?? "crm--targets-index",
    path: indexSXDzfHq9KBMeta?.path ?? "/crm/targets",
    meta: indexSXDzfHq9KBMeta || {},
    alias: indexSXDzfHq9KBMeta?.alias || [],
    redirect: indexSXDzfHq9KBMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/crm/pages/targets/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_935RndewZdFQMeta?.name ?? "users-pages-id",
    path: _91id_935RndewZdFQMeta?.path ?? "/users/:id",
    meta: _91id_935RndewZdFQMeta || {},
    alias: _91id_935RndewZdFQMeta?.alias || [],
    redirect: _91id_935RndewZdFQMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/[id].vue").then(m => m.default || m)
  },
  {
    name: indexIVGx66AxoKMeta?.name ?? "users-pages-index",
    path: indexIVGx66AxoKMeta?.path ?? "/users",
    meta: indexIVGx66AxoKMeta || {},
    alias: indexIVGx66AxoKMeta?.alias || [],
    redirect: indexIVGx66AxoKMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexJleyiNlNJgMeta?.name ?? "users-pages-reports-index",
    path: indexJleyiNlNJgMeta?.path ?? "/users/reports",
    meta: indexJleyiNlNJgMeta || {},
    alias: indexJleyiNlNJgMeta?.alias || [],
    redirect: indexJleyiNlNJgMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/users/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93mpRotZ6tHpMeta?.name ?? "profile-pages-id",
    path: _91id_93mpRotZ6tHpMeta?.path ?? "/profiles/:id",
    meta: _91id_93mpRotZ6tHpMeta || {},
    alias: _91id_93mpRotZ6tHpMeta?.alias || [],
    redirect: _91id_93mpRotZ6tHpMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/[id].vue").then(m => m.default || m)
  },
  {
    name: indextgwTkjHRa7Meta?.name ?? "profile-pages-dashboard-index",
    path: indextgwTkjHRa7Meta?.path ?? "/profiles/dashboard",
    meta: indextgwTkjHRa7Meta || {},
    alias: indextgwTkjHRa7Meta?.alias || [],
    redirect: indextgwTkjHRa7Meta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexYfHobTMMtYMeta?.name ?? "profile-pages-index",
    path: indexYfHobTMMtYMeta?.path ?? "/profiles",
    meta: indexYfHobTMMtYMeta || {},
    alias: indexYfHobTMMtYMeta?.alias || [],
    redirect: indexYfHobTMMtYMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexGkuUquOk0UMeta?.name ?? "profile-pages-reports-index",
    path: indexGkuUquOk0UMeta?.path ?? "/profiles/reports",
    meta: indexGkuUquOk0UMeta || {},
    alias: indexGkuUquOk0UMeta?.alias || [],
    redirect: indexGkuUquOk0UMeta?.redirect || undefined,
    component: () => import("/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/projects/profiles/pages/reports/index.vue").then(m => m.default || m)
  }
]